import React from 'react'
import PropTypes from 'prop-types'
import { Checkbox as AntCheckbox } from 'antd'
import classNames from 'classnames'
import { useController } from 'react-hook-form'

const CheckboxGroup = (props) => {
  const {
    name,
    className,
    defaultValue,
    children,
    rules,
    ...restProps
  } = props

  const {
    field: {
      onChange,
      value,
      ref,
      onBlur,
    },
    fieldState: { invalid },
  } = useController({
    name,
    rules,
    defaultValue,
  })

  return (
    <AntCheckbox.Group
      {...restProps}
      ref={ref}
      onBlur={onBlur}
      onChange={onChange}
      value={value}
      className={classNames(className, 'form__checkbox-group', {
        'form__checkbox-group--invalid': invalid,
      })}
    >
      {children}
    </AntCheckbox.Group>
  )
}

CheckboxGroup.Item = AntCheckbox

CheckboxGroup.propTypes = {
  name: PropTypes.string.isRequired,
  defaultValue: PropTypes.array,
  className: PropTypes.string,
  children: PropTypes.node,
  rules: PropTypes.object,
}

export default CheckboxGroup
